<template>

  <div class="user">
    <!--添加任务-->
    <div class="common-seach-wrap">
      <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">
        <el-form-item label="名称">
          <el-input placeholder="请输入隐患排查检查项名称" v-model="formInline.search">
        
          </el-input>
        </el-form-item>
        <el-form-item >
          <el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item>

      </el-form>
    </div>

    <div class="common-level-rail">
      <el-button size="small" icon="el-icon-plus" type="primary" @click="addClick">添加隐患排查检查项</el-button>
    </div>

    <div class="product-content">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading" row-key="inspection_id" default-expand-all :tree-props="{children: 'children'}">
            <el-table-column prop="name" label="名称"></el-table-column>
            <el-table-column label="状态" align="center">
              <template slot-scope="scope">
                <el-switch
                  v-model="scope.row.status"
                  :active-value="1"
                  :inactive-value="0"
                  @change="handleStatusChange(scope.row)"
                  active-color="#13ce66"
                ></el-switch>
              </template>
            </el-table-column>
            <el-table-column prop="sort" label="排序" ></el-table-column>
            <el-table-column prop="create_time" label="创建时间" width="150"></el-table-column>
            <el-table-column fixed="right" label="操作" width="90">
              <template slot-scope="scope">
                <el-button @click="editClick(scope.row)" type="text" size="small">编辑</el-button>
                <el-button @click="deleteClick(scope.row)" type="text" size="small">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
    </div>
    
    <Add :open_add="open_add" v-if="open_add" @close="closeAdd" :p_id="p_id"></Add>
    <Edit :open_add="open_edit" :inspection_id="inspection_id" v-if="open_edit"   @close="closeEdit"></Edit>

    <el-dialog  style="text-align: center" title="设置标题" :visible.sync="dialogVisible" @close='dialogFormVisible' 
    :close-on-click-modal="false" 
               :close-on-press-escape="false" :append-to-body="true">
    </el-dialog>
  
  </div>
</template>

<script>
  import AfuncApi from '@/api/afunc.js'
  import Add from './part/add.vue';
  import Edit from './part/edit.vue';

  export default {
    components: {
      Add,
      Edit,
      AfuncApi
    },
    inject: ['reload'],
    data() {
      return {
        loading: true,
        tableData: [],
        form: {},
        formInline: {
          search:""
        },
        open_add:false,
        open_edit:false,
        dialogVisible:false,
        inspection_id:0,
        p_id:0
      };
    },
    created() {
      this.initInspectionId();
      this.getTableList();
    },
    watch: {
      '$route.query': {
        immediate: true, 
        handler() {
          this.initInspectionId(); 
          this.getTableList(); 
        }
      }
    },
    methods: {
      dialogFormVisible(){
        this.dialogVisible = false;
      },
      setting(e){//隐患排查检查项标题设置
        this.dialogVisible = true;
      },
      /*关闭添加*/
      closeAdd(e){
        this.open_add=false;
        this.getTableList();
      },
      closeEdit(e){
        this.open_edit=false;
        this.getTableList();
      },
      onSubmit(){
        this.getTableList();
      },
      initInspectionId() {
        const routeInspectionId = this.$route.query.p_id || 0;
        this.p_id = Number(routeInspectionId);
      },
      async getTableList() {
        this.loading = true;
        try {
          const response = await AfuncApi.call({
            model: 'inspection',
            action: 'index',
            p_id: this.p_id,
            search: this.formInline.search
          })
          if (response.code === 1 && response.data) {
            const listData = response.data.list.data || []
            this.tableData = this.buildTreeData(listData);
            this.parentOptions = this.tableData;
          } else {
            this.tableData = [];
            this.parentOptions = [];
          }
        } catch (error) {
          console.error('加载检查项列表失败:', error)
          this.$message.error('加载检查项列表失败')
          this.tableData = [];
          this.parentOptions = [];
        } finally {
          this.loading = false;
        }
      },

      buildTreeData(listData) {
        return listData.map(item => {
          const newItem = { ...item };
          if (newItem.grandchildren && newItem.grandchildren.length > 0) {
            newItem.children = newItem.grandchildren.map(subItem => {
              const newSubItem = { ...subItem };
              if (newSubItem.children && newSubItem.children.length > 0) {
                newSubItem.children = newSubItem.children.map(thirdItem => ({ ...thirdItem }));
              }
              return newSubItem;
            });
          }
          return newItem;
        });
      },

      addClick() {
        this.p_id = 0;
        this.open_add = true;
      },

      editClick(row) {
        this.inspection_id = row.inspection_id;
        this.open_edit = true
      },

      async handleStatusChange(row) {
        if (!row || !row.inspection_id) {
          this.$message.warning('数据异常，无法修改状态');
          return;
        }
        try {
          const response = await AfuncApi.call({
            model: 'inspection',
            action: 'editStatus',
            inspection_id:row.inspection_id,
            status:row.status
          });
          if (response.code === 1) {
            this.$message.success('状态更新成功');
          } else {
            this.$message.error(response.msg || '状态更新失败');
            row.status = row.status === 1 ? 0 : 1;
          }
        } catch (error) {
          console.log(error,'error')
          this.$message.error('状态更新失败');
          row.status = row.status === 1 ? 0 : 1;
        }
      },

      async deleteClick(row) {
        try {
          await this.$confirm(
            '此操作将永久删除该记录, 是否继续?', 
            '提示', 
            {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }
          );

          const response = await AfuncApi.call({
            model: 'inspection',
            action: 'del',
            inspection_id: row.inspection_id 
          });

          if (response.code === 1) {
            this.$message({
              message: '删除成功',
              type: 'success'
            });
            this.getTableList();
          } else {
            this.$message.error(response.msg || '删除失败，请稍后重试');
          }
        } catch (error) {
          if (error !== 'cancel') { 
            console.error('删除检查项失败:', error);
            this.$message.error('删除失败，接口请求异常');
          } else {
            this.$message.info('已取消删除'); 
          }
        }
      },
    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/inspection/index/index.vue